import React from "react";
import "./Capabilities.css";

const Capabilities = () => {
  const capabilities = [
    {
      id: 1,
      icon: "🎯",
      title: "Mission-Ready Common Operating Picture",
      description:
        "Real-time situational awareness with integrated geospatial data, providing commanders with comprehensive mission context and rapid decision-making capabilities.",
      features: [
        "Live data integration",
        "Multi-source intelligence",
        "Real-time updates",
        "Operational dashboards",
      ],
    },
    {
      id: 2,
      icon: "📊",
      title: "Integrated Cost, Schedule & Risk Management",
      description:
        "Advanced analytics platform that connects cost, schedule, and risk intelligence in a unified view for confident, data-driven decision making.",
      features: [
        "Predictive analytics",
        "Risk assessment",
        "Cost optimization",
        "Schedule tracking",
      ],
    },
    {
      id: 3,
      icon: "⚡",
      title: "Rapid Experimentation & Prototyping",
      description:
        "Accelerate innovation with AI-powered scenario modeling and rapid prototyping tools that test numerous configurations instantly.",
      features: [
        "AI scenario modeling",
        "Rapid prototyping",
        "Configuration testing",
        "Innovation acceleration",
      ],
    },
    {
      id: 4,
      icon: "🔬",
      title: "Advanced Testing & Validation",
      description:
        "Comprehensive testing environment for new technologies and workflows before operational deployment, ensuring mission readiness.",
      features: [
        "Technology validation",
        "Workflow testing",
        "Pre-deployment assessment",
        "Quality assurance",
      ],
    },
    {
      id: 5,
      icon: "🤖",
      title: "AI-Augmented Workforce & Workflows",
      description:
        "Intelligent automation that enhances human expertise by handling repetitive tasks while maintaining the highest standards of quality.",
      features: [
        "Intelligent automation",
        "Quality standardization",
        "Workflow optimization",
        "Expert augmentation",
      ],
    },
  ];

  return (
    <section id="features" className="capabilities">
      <h2 className="features-title">Features</h2>
      <div className="capabilities-container">
        {capabilities.map((cap, index) => (
          <div
            key={cap.id}
            className={`capability-row ${
              index % 2 === 0 ? "left-align" : "right-align"
            }`}
          >
            <div className="capability-content">
              <div className="capability-icon">
                <span className="icon-emoji">{cap.icon}</span>
              </div>
              <h3 className="capability-title">{cap.title}</h3>
              <p className="capability-description">{cap.description}</p>
              <ul className="capability-features">
                {cap.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </div>
            {/* <div className="capability-visual">
              <div className="capability-placeholder">
                <div className="placeholder-content">
                  <span className="placeholder-icon">{cap.icon}</span>
                  <p>Interactive Demo</p>
                </div>
              </div>
            </div> */}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Capabilities;
